import {Modal} from 'antd'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useState} from 'react'
import {BsArrowsMove} from 'react-icons/bs'
import {useToggle} from 'react-use'
import {NullAsDefault} from 'views/Shared'
import DraggableWidget from 'views/Shared/components/DraggableWidget'

const DnDSorter = ({
  style,
  className,
  children,
  onSubmit = NullAsDefault,
  data = [],
}) => {
  const t = useTranslate()

  const [isToggle, toggle] = useToggle(false)

  const [orderedList, setOrderList] = useState([])

  const onDrop = ({ items, draggableId, destination: order_number }) => {
    setOrderList(items)
  }

  useEffect(() => {
    const array = data.map(({ id }) => id)
    if (!_.isEqual(array, orderedList)) {
      setOrderList(array)
    }
  }, [data])

  return (
    <div {...{ style, className }}>
      {_.isFunction(children)
        ? children({
            toggle,
            isToggle,
          })
        : children}
      {isToggle && (
        <Modal
          title={
            <div className="text-center text-color-000 font-semibold uppercase">
              {t(t('order sort'))}
            </div>
          }
          open={!!isToggle}
          okText={t('save')}
          cancelText={t('cancel')}
          okButtonProps={{
            className: 'button-rounded-lg no-border',
          }}
          cancelButtonProps={{
            className: 'button-rounded-lg no-border',
          }}
          onOk={() => {
            onSubmit(orderedList)
            toggle(false)
          }}
          onCancel={() => toggle(false)}>
          <DraggableWidget
            key={orderedList}
            data={Array.from(orderedList || []).map((id) =>
              _.find(data, { id })
            )}
            sortBy="order_sort"
            onCompleted={onDrop}
            withClassNames={(isDragging, classNames) => [
              ...classNames,
              'border rounded-lg mb-2',
              isDragging
                ? 'border-primary bg-primary-50'
                : 'background border-color-50',
            ]}
            itemClassName="w-full p-2 flex flex-col space-y-2"
            renderItem={(row = {}, { isDragging = false }) => (
              <div className="flex gap-3">
                <BsArrowsMove className="text-color-400 mt-1" />
                <div className="flex flex-col flex-1">
                  <span className="text-sm font-medium">
                    {getTitle(row)}
                  </span>
                </div>
              </div>
            )}
          />
        </Modal>
      )}
    </div>
  )
}

export default DnDSorter
